import React, { useMemo } from 'react';
import { useLaboratoryRequisitionPrimarySamplesQuery } from '../../../../graphql/graphql';
import Loading, { LoadingSize } from '../../../../Components/Loading';
import RadioList, {
	RadioListItem,
} from '../../../../Components/Base/RadioList/RadioList';

interface Props {
	requisitionId: string;
	onChange?: (value: RadioListItem) => void;
}

const LaboratoryPrimarySampleSelection: React.FC<Props> = ({
	requisitionId,
	onChange,
}) => {
	const { data, isLoading } = useLaboratoryRequisitionPrimarySamplesQuery({
		where: { id: requisitionId },
	});

	const options: RadioListItem[] = useMemo(() => {
		const temp: RadioListItem[] = [];
		data?.laboratoryRequisitionPrimarySamples?.forEach(item => {
			if (!item.name || !item.value) return;
			temp.push({ title: item.name, value: item.value });
		});
		return temp;
	}, [data]);

	if (isLoading) {
		return <Loading size={LoadingSize.SMALL} />;
	}

	return <RadioList data={options} inLine onChange={onChange} />;
};

export default LaboratoryPrimarySampleSelection;
